import { StyleObject } from 'styletron-standard';
import { Theme } from '../../Themes/themeProvider/ThemeProvider';
import { marginSize } from '../../Utilities/utils/Theming';

export const ListItemStyle = ({
	$theme = Theme,
	$selected,
	$isHighlighted,
	$disabled,
	size,
	isCustom,
}: {
	$theme: typeof Theme;
	$isHighlighted: boolean;
	size?: string;
	$disabled?: boolean;
	$selected: boolean;
	isCustom?: boolean;
}) => {
	const {
		list: { listItemHoverBorder, listItemBorderRadius, listItemTransparentBorder },
	} = $theme;

	const _hoverDisabled = $disabled ? { borderColor: "transparent" } : {}

	return {
		color: $disabled ? 'var(--epods--color-text-disabled)' : 'var(--epods--color-text-primary)',
		height:
			isCustom ? 'var(--epods--list-item-custom-height)'
				: size === 'large'
					? 'var(--epods--list-item-large-height)'
					: size === 'compact'
						? 'var(--epods--list-item-compact-height)'
						: size === 'mini'
							? 'var(--epods--list-item-mini-height)'
							: 'var(--epods--list-item-default-height)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		fontFamily: 'var(--epods--font-secondary)',
		fontWeight: '100',
		fontSize:
			size === 'compact'
				? 'var(--epods--dropdown-compact-font-size)'
				: size === 'large'
					? 'var(--epods--dropdown-large-font-size)'
					: size === 'mini'
						? 'var(--epods--dropdown-mini-font-size)'
						: 'var(--epods--dropdown-default-font-size)',
		...marginSize(
			'var(--epods--space-inset-xs)',
			'var(--epods--space-inset-xs)',
			'var(--epods--space-inset-xs)',
			'var(--epods--space-inset-xs)',
		),
		paddingTop: 'var(--epods--space-inset-xs)',
		paddingBottom: 'var(--epods--space-inset-xs)',
		paddingLeft: 'var(--epods--space-inset-s)',
		paddingRight: 'var(--epods--space-inset-s)',
		backgroundColor: $selected
			? 'var(--epods--color-bg-active)'
			: $isHighlighted
				? 'var(--epods--color-bg-visited)'
				: 'none',
		borderRadius: listItemBorderRadius,
		border: listItemTransparentBorder,
		':hover': {
			border: listItemHoverBorder,
			..._hoverDisabled,
			backgroundColor: $selected
				? 'var(--epods--color-bg-active)'
				: $isHighlighted
					? 'var(--epods--color-bg-visited)'
					: 'transparent',
		},
		':disabled, [aria-disabled="true"]': {
			backgroundColor: 'transparent !important',
			color: 'var(--epods--color-text-disabled)',
		},
	} as StyleObject;
};
